<template>
	<div class="homeWrap">
		<div class="adWrap" id='AD'>
			<div class="swiper swiper-container" >
				<div class="swiper-wrapper" id='adWrap'></div>
				<div class="swiper-pagination"></div>
			</div>
		</div>
		<el-row :gutter="10" class="introduction">
			<el-col :span="16" class="left">
				<section>
					<h3>什么是出行券</h3>
					<p class="intro_a">出行券是由{{ isOldGroup ?
							"滴滴出行" : "桔财动力"
					}}旗下业务提供的包括专车、快车、通用、代驾、豪华车的可自定义外观和使用条件的单次行程定额抵扣券。</p>
					<p class="intro_b">由企业发放给企业的客户，客户在行程结束后可定额抵扣。<br>为企业的客户提供更多选择的会员权益和营销服务，助力企业发展。</p>
					<span class="getRule" @click.prevent.stop="dialogRule = true">了解使用规则</span>
					<p class="tips">*若您对出行券有定制化需求，我们可提供专属解决方案 <span
							@click.prevent.stop="openNewTab('https://page.xiaojukeji.com/active/ddpage_0IcG5OMl.html')">查看详情</span>
					</p>
				</section>
			</el-col>
			<el-col :span="8" class="right">
				<section>
					<h3>只需2步，发放出行券</h3>
					<ul class="stepWrap">
						<li>
							<span>1</span>
							<h5>购券</h5>
							<router-link  @click.native="omgUp('购券管理')" class="alink" to="/purchasecoupon/purchase">购券管理</router-link>
							<p>充值或在线支付购买出行券</p>
							<span v-if="hasDiscount" class="discountIcon">限时{{discountInfo ? discountInfo.discount: '--'}}折</span>
						</li>
						<li class="last">
							<span>2</span>
							<h5>发券</h5>
							<router-link @click.native="omgUp('发券管理')" class="alink" to="/sendcoupon/sendbyphone">发券管理</router-link>
							<p>通过手机号发放到用户账户</p>
						</li>
					</ul>
				</section>
			</el-col>
		</el-row>
		<section>
			<h3>统计信息</h3>
			<ul class="operaWrap">
				<li>
					<div class="contentWrap">
						<div class="title">
							<i></i>
							可用余额
						</div>
						<div class="content">
							{{ availableBalance }}
							<span>元</span>
						</div>
						<el-button v-if="!isOldGroup" @click="btnClick('/recharge/recharge','可用余额-充值')">充值</el-button>
					</div>
				</li>
				<li>
					<div class="contentWrap">
						<div class="title">
							<i class="sen"></i>
							剩余可发张数
						</div>
						<div class="content">
							{{ availableCouponNumber }}
							<span>张</span>
						</div>
						<el-button @click="btnClick('/sendcoupon/sendbyphone','剩余可发张数-发券')">发券</el-button>
					</div>
				</li>
				<li>
					<div class="contentWrap">
						<div class="title">
							<i class="thr"></i>
							近30日发券张数
						</div>
						<div class="content">
							{{ sendCouponNumber }}
							<span>张</span>
						</div>
						<el-button @click="btnClick('/sendcoupon/history','近30日发券张数-查看')">查看</el-button>
					</div>
				</li>
				<li>
					<div class="contentWrap">
						<div class="title">
							<i class="for"></i>
							7日内将过期张数
						</div>
						<div class="content">
							{{ willExpireCouponNumber }}
							<span>张</span>
						</div>
						<el-button @click="btnClick('sendcoupon/sendbyphone','7日内过期张数-发券')">发券</el-button>
					</div>
				</li>
			</ul>
		</section>
		<section>
			<h3 class="clearfix">
				成功案例
				<!-- <a href="es.xiaoju.com" target="_blank" class="moreCase">更多<i class="el-icon-arrow-right"></i></a> -->
			</h3>
			<div class="caseWrap">
				<article>
					<a href="https://es-static.xiaojukeji.com/static/web/home/indexyintai.html" @click="omgUp('成功案例-银泰百货')" target="_blank">
						<header>
							<img src="../images/caseA.jpg" alt="">
						</header>
						<h5>商超百货<br>用出行券提升顾客到店复购率</h5>
						<!-- <p>阿里巴巴是全球企业(B2B)电子商务的著名品牌，为数千万网商提供海量商...</p> -->
					</a>
				</article>
				<article>
					<a href="https://es-static.xiaojukeji.com/static/web/home/indexciji.html"  @click="omgUp('成功案例-4S店')" target="_blank">
						<header>
							<img src="../images/caseB.jpg" alt="">
						</header>
						<h5>浙江慈吉之星<br>用出行券为车主客户提供VIP尊享服务</h5>
						<!-- <p>阿里巴巴是全球企业(B2B)电子商务的著名品牌，为数千万网商提供海量商...</p> -->
					</a>
				</article>
			</div>
		</section>
		<el-dialog :visible.sync="dialogRule" width="700px" title="出行券使用规则" custom-class="dialogWrap">
			<div>
				<p>1）多张出行劵使用不可叠加，不可兑换现金，不找零。</p>
				<p>2）一张出行劵只能使用一次，不可做储蓄卡使用。</p>
				<p>3）出行劵不可与其他优惠叠加使用。</p>
				<p>4）用户使用出行券应同时满足以下条件：</p>
				<p class="list mt5">①.用户已开通微信或支付宝功能，并且通过实名认证或者绑定了银行卡；</p>
				<p class="list">②.用户使用滴滴APP，在开通快车/专车/豪华车/代驾服务的城市/地区发送叫车信息并乘坐应答的车型；</p>
				<p class="list">③.用户的订单符合券面注明的使用条件；</p>
				<p class="list">④.用户未违反{{ isOldGroup ? "滴滴出行" : "桔财动力" }}平台使用规则，且该笔订单不属于{{ isOldGroup ?
						"滴滴出行" : "桔财动力"
				}}平台判定的作弊或类似作弊订单等禁用出行券的情况。</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click.prevent.stop="dialogRule = false">已经了解</el-button>
			</div>
		</el-dialog>
		<!-- <el-dialog
            :visible.sync="dialogFeedback"
            width ="700px"
            title="定制化需求"
            custom-class = "dialogWrap"
        >    
			<div>
				<p>如有定制化需求，请发邮件到 <span class="mail">didichuxingquan@didichuxing.com</span>。邮件模板如下：</p>
				<p class="mt10">标题：【需求反馈】公司名+登录手机号</p>
				<p>内容：企业版账户名称、联系人、出行券登录手机号、需求反馈或建议等、其他说明</p>
			</div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click.prevent.stop="dialogFeedback = false">已经了解</el-button>
            </div>
        </el-dialog> -->
	</div>

</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { loadScript } from 'Plugins/helper'
import Swiper from "swiper"
import 'swiper/dist/css/swiper.min.css'
export default {
	beforeMount: function () {
		// console.log(moment().isBefore('2018-12-31 23:59:59'))
		// console.log(1111, Object.keys(this.$store.state.header.selfGroup))
		if (this.$store.state.header.selfGroup && Object.keys(this.$store.state.header.selfGroup).length > 0) {
			if (this.$store.state.header.selfGroup.role === 0) {
				this.$store.dispatch('home/getGroupInfoForHomePage', {
					groupId: this.$store.state.header.selfGroup.groupId
				})
			}
		}
	},
	mounted: function () {
		const { phone } = this.$store.state.header.userInfo
		loadScript('//es-static.xiaojukeji.com/static/web/public/js/moongazing.min.js?t=' + (new Date).getTime(), () => {
			window.moongazing && window.moongazing.init(4, { adWrap: 'es_cxq_home_banner' }, { phone: phone }).afterRender(() => {
				document.getElementById('AD').style.marginBottom = '10px'
				var mySwiper = new Swiper('.swiper-container', {
					autoplay: true,
					pagination: {
						el: ".swiper-pagination",
					},
				})
			})
		})
		this.omgTrack('es_chuxingquan_home_sw', '出行券_首页_曝光')
	},
	data() {
		return {
			isShowSale: moment().isBefore('2018-12-31 23:59:59'),
			dialogRule: false,
			dialogFeedback: false
		}
	},
	computed: {
		isOldGroup: function () {
			console.log(this.$store.state.header.selfGroup.version)
			return this.$store.state.header.selfGroup.version == 0 ? true : false
		},
		...mapState('home', {
			availableBalance: state => {
				return (state.availableBalance).toLocaleString('en-US')
			},
			availableCouponNumber: state => state.availableCouponNumber,
			sendCouponNumber: state => state.sendCouponNumber,
			willExpireCouponNumber: state => state.willExpireCouponNumber
		}),
		...mapState('header', ['hasDiscount','discountInfo'])
	},
	methods: {
		btnClick: function (url,str) {
			this.omgTrack('es_chuxingquan_home_ck', '出行券_首页_点击',{icon:str})
			this.$router.push(url).catch(err => { })
		},
		openNewTab: function (href) {
			window.open(href, '_blank')
		},
		omgUp:function(str){
			this.omgTrack('es_chuxingquan_home_ck', '出行券_首页_点击',{icon:str})
		}
	},
	watch: {
		'$store.state.header.selfGroup': function (val) {
			// console.log('2ewwe')
			this.$store.dispatch('home/getGroupInfoForHomePage', {
				groupId: val.groupId
			})
		}
	}
}
</script>
<style lang="stylus">
.homeWrap
  background #eee 
  section
    background #fff
    margin-bottom 10px
    border-radius 2px
    padding-bottom 30px
    h3
      font-size: 24px;
      color: #333333;
      letter-spacing: 0;
      font-weight 300
      height 34px
      line-height  34px
      padding 20px 0 20px 20px
      margin 0
      position relative
    &:last-child
      margin 0
	.introduction
		margin-bottom:10px;
		.left
			section
				background:url('../images/introduceLeftBg.jpg') no-repeat right top;
				background-color :#fff;
				background-size: auto 250px;
				padding-bottom 25px;
				height 225px
				overflow hidden
				p
					padding-left:20px;
					line-height:20px;
					letter-spacing: 0;
					width:460px;
					font-size: 14px;
				.intro_a
					color: #333333;
					font-weight:500;
				.intro_b
					font-weight:400;
					padding-top: 5px;
					color: #666666;
				.getRule
					padding-left:20px;
					font-size: 14px;
					font-weight:500;
					color: #3468FF;
					padding-top:10px;
					letter-spacing: 0;
					display inline-block;
					cursor pointer;
				.tips
					padding-top 18px;
					font-size: 12px;
					color: #999999;
					font-weight:300;
					span
						cursor pointer;
						font-weight:500;
						font-size: 12px;
						color: #333333;
		.right
			section
				padding-bottom 25px;
				height 225px
				overflow hidden
				.stepWrap{
					padding  0 30px 0 55px;
					li{
						border-bottom 1px solid #E5E5E5;
						position relative;
						padding-bottom 20px
						span {
							display block;
							width 20px;
							height 20px;
							border-radius 10px;
							border: 1px solid #E5E5E5;
							text-align center;
							line-height 20px;
							font-size: 12px;
							color: #999999;
							position absolute;
							left: -27px;
    						top: 0;
						}
						h5{
							font-size: 14px;
							color: #333333;
							font-weight 500;
							margin 0;
							padding: 0 0 5px 0;
						}
						p{
							font-size: 12px;
							font-weight 400;
							color: #666666;				
						}
						.alink{
							position: absolute;
							right: 0;
							top: 0;
						}
						a{
							text-decoration none
							font-size 14px
							color #3468FF
							letter-spacing 0
						}	
						.discountIcon{
							padding: 0 4px;
							width: initial;
							height: 16px;
							opacity: 1;
							display: block;
							position: absolute;
							left: 32px;
							top: 2px;
							border: none;
							background: linear-gradient(108deg, #ff975c 3%, #f00 100%);
							/* font-family: PingFangSC-Medium; */
							font-size: 10px;
							font-weight: normal;
							line-height: 16px;
							letter-spacing: 0px;
							color: #fff;
							text-align: center;
							border-radius: 2px 2px 2px 0px;
						}
					}
					.last{
						border none;
						padding-bottom: 0;
    					margin-top: 20px;
					}
				}
				
			
.moreCase
  font-size 14px
  color #666666
  letter-spacing 0
  margin-right 30px
  text-decoration none
  font-weight 400
  display inline
  position absolute
  width 50px
  right 0
.caseWrap
  display flex
  justify-content space-between
  padding 0 10px
article
  width 50%
  margin 0 10px
  border-radius 5px
  box-shadow 0 2px 20px 0 rgba(0,0,0,0.06)
  overflow hidden
  height 235px
  a
    text-decoration none
  header
    height 149px
    overflow hidden
    img
      width 100%
  h5
    padding 0 16px
    font-size 16px
    color #333333
    line-height 22px
    margin 16px 0 5px
    font-weight 500
  p
    padding 0 16px
    font-size 12px
    color #666666
    letter-spacing -0.1px
    line-height 17px
    font-weight 300
article:hover
  transform translate(0,-5px)
  transition transform .2s linear
.operaWrap
  display flex
  padding 10px 0 24px
  justify-content space-around
  li
    width 25%
    display flex
    justify-content center
    position relative
  .contentWrap
    position relative
    .title
      font-size 14px
      color #333333
      font-weight 500
      position relative
      i
        display block
        font-size 0
        height 6px
        width 5px
        background #FF8249
        border-radius 1px
        transform skewX(-10deg)
        position absolute
        left -8px
        top 7px
      .sen
        background #FFB558
      .thr
        background #4DBF84
      .for
        background #3468FF
    .content
      font-size 32px
      font-weight 500
      line-height 40px
      height 40px
      margin-top 6px
      font-family 'DIN-Medium'
      span
        font-weight 300
        font-size  12px
        color  #333333
        line-height  14px
        position relative
        left -5px

    .el-button
      margin-top 16px

  li:not(:last-child):after
    content ''
    width 1px
    height 80px
    background #e5e5e5
    position absolute
    right 0
    top 15px
.clearfix:after
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
.dialog-footer
    .el-button
        height 44px
        line-height 1
        padding 0 44px
    .el-button+.el-button
        margin-left 20px
.dialogWrap
	.el-dialog__body{
		border-bottom  1px solid #E5E5E5;
		padding-top 10px
	}
	.dialog-footer{
		text-align center;
	}
	.el-dialog__footer
		padding 20px;
		.el-button
			font-size 14px;
			font-weight 500;
	.el-dialog__header
		padding: 30px 20px 10px 40px;
		span
			font-size 20px
			font-weight 500
		.el-dialog__headerbtn
			i
				font-size 22px
	p
		font-size: 14px;
		line-height: 20px;
		color: #3F3F3F;
		padding 0 20px;
	.list
		font-size 12px
		color: #999;
.mt10
	margin-top 10px
.mt5
	margin-top 5px
.mail
	color #3468FF
.adWrap{
		// a{
			display:block;
			background:#fff;
			border-radius:2px;
			overflow hidden;
			width :100%;
		a{
			width: 100%
		}
		// 	img {
		// 		width 100%;
		// 		height auto;
		// 		display: block;
		// 	}
		// }
}
.swiper-container {
        width: 100%;
        height: 100%;
      }

      .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
      }

      .swiper-slide img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
	  .swiper-pagination-bullet {
		width: 34px;
		height: 3px;
		text-align: center;
		line-height: 3px;
		font-size: 0px;
		opacity: 0.6;
		border-radius: 0;
		background: #fff;
      }

      .swiper-pagination-bullet-active {
    	opacity: 1;
      }
</style>
